<template>
	<TypographyTitle :level="2">
		{{ $t('add-rover.header') }}
	</TypographyTitle>

	<div class="form-background max-width-750">
		<Form
			:model="formState"
			name="basic"
			:label-col="{ span: 8 }"
			:wrapper-col="{ span: 16 }"
			autocomplete="off"
			@finish="onFinish"
		>
			<FormItem
				:label="$t('add-rover.form.uid')"
				name="uid"
				:rules="[{ required: true, message: $t('add-rover.validators.uid') }]"
			>
				<Input v-model:value="formState.uid" ref="uidField" />
			</FormItem>

			<FormItem
				:label="$t('add-rover.form.password')"
				name="password"
				:rules="[{ required: true, message: $t('add-rover.validators.password') }]"
			>
				<InputPassword v-model:value="formState.password" />
			</FormItem>

			<FormItem
				:label="$t('add-rover.form.label')"
				name="label"
				:rules="[{ required: true, message: $t('add-rover.validators.label') }]"
			>
				<Input v-model:value="formState.label" @change="onLabelChange" />
			</FormItem>

			<FormItem :wrapper-col="{ xs: { span: 24 }, sm: { offset: 8, span: 16 } }">
				<Button type="primary" html-type="submit" :disabled="isLoading" :loading="isLoading">
					{{ $t('add-rover.form.submitButtonLabel') }}
				</Button>
			</FormItem>
		</Form>
	</div>
</template>

<script>
import { reactive, ref, toRaw, watch } from 'vue';
import { TypographyTitle, Form, FormItem, Input, InputPassword, Button, message } from 'ant-design-vue';

import { useRouter } from 'vue-router';

import { useI18n } from 'vue-i18n'

import { useFocusOnMounted } from '@/utils/useFocusOnMounted';

import { showErrorMessage } from '@/components/common/errorMessage';

import Api from '@/api/Api';

export default {
	components: {
		TypographyTitle, Form, FormItem, Input, InputPassword, Button,
	},
	setup() {
		const { t } = useI18n();
		const syncUidLabel = ref(true);
		const formState = reactive({
			uid: '',
			password: '',
			label: '',
		});
		const isLoading = ref(false);
		watch(() => formState.uid, () => {
			if (syncUidLabel.value) {
				formState.label = formState.uid;
			}
		});

		const onLabelChange = () => { syncUidLabel.value = false };

		const router = useRouter();
		const onFinish = values => {
			isLoading.value = true;
			Api.roverAdd(
				toRaw(values),
				response => {
					isLoading.value = false;
					if (response.status === 'ok') {
						message.success(t('add-rover.messages.roverAdded'));
						router.push({ name: 'rovers' });
					} else {
						showErrorMessage(response.errors);
					}
				},
			);
		}

		const uidField = ref();
		useFocusOnMounted(uidField);
		return {
			formState,
			isLoading,
			onFinish,
			uidField,
			onLabelChange,
		};
	},
}
</script>
